module.exports = __webpack_public_path__ + "media/vidcartoon-hobby.34a85b86.mp4";